import { api, get, post } from '@/lib/api';

const patch = <T>(caminho: string, corpo: unknown) =>
  api<T>(caminho, { method: 'PATCH', body: corpo });

const del = (caminho: string) => api<unknown>(caminho, { method: 'DELETE' });

const BASE = '/projects';

// ── tipos ────────────────────────────────────────────────────────────────────

export interface Sprint {
  id: string;
  name: string;
  goal?: string | null;
  startAt: number;
  endAt: number;
  status: 'PLANNING' | 'ACTIVE' | 'COMPLETED';
  tasks: Array<{ id: string; name: string; progress: number; isCritical: boolean }>;
}

// ── consultas ────────────────────────────────────────────────────────────────

export const listarSprints = (projetoId: string) =>
  get<Sprint[]>(`${BASE}/${projetoId}/sprints`);

// ── mutações ─────────────────────────────────────────────────────────────────

export const criarSprint = (
  projetoId: string,
  data: { name: string; goal?: string; startAt: number; endAt: number },
) => post<Sprint>(`${BASE}/${projetoId}/sprints`, data);

export const atualizarSprint = (
  projetoId: string,
  sprintId: string,
  data: { name?: string; goal?: string; status?: string },
) => patch<Sprint>(`${BASE}/${projetoId}/sprints/${sprintId}`, data);

export const excluirSprint = (projetoId: string, sprintId: string) =>
  del(`${BASE}/${projetoId}/sprints/${sprintId}`) as Promise<{ ok: boolean }>;
